/**
 * Heuristic for webpack chunk-load failures after deploy.
 * Typical messages:
 * - "Loading chunk 239 failed."
 * - "ChunkLoadError: Loading chunk 239 failed."
 */
export function isChunkLoadError(err: unknown): err is Error {
  if (!(err instanceof Error)) return false;
  if (err.name === "ChunkLoadError") return true;
  return /Loading chunk \d+ failed/i.test(err.message);
}

/**
 * Sometimes chunk request returns an error payload (e.g. 403 JSON: "{...}") instead of JS.
 * Browser tries to execute it as a script and throws "Unexpected token '{'".
 */
export function isChunkLoadSyntaxError(err: unknown): err is SyntaxError {
  if (!(err instanceof SyntaxError)) return false;
  return /Unexpected token/.test(err.message);
}

/**
 * One-shot hard reload to recover from stale runtime/main requesting missing chunks.
 * We guard with sessionStorage to avoid infinite reload loops.
 */
export function recoverFromChunkLoadError(): void {
  try {
    const key = "ma:chunk-load-recovery:v1";
    const alreadyTried = sessionStorage.getItem(key) === "1";
    if (alreadyTried) return;
    sessionStorage.setItem(key, "1");
    window.location.reload();
  } catch {
    // If sessionStorage is blocked, still attempt a reload once.
    window.location.reload();
  }
}
